import React from "react";
import Home from "../../../../assets/teams/home.png";
import Away from "../../../../assets/teams/away.png";
import Draw from "../../../../assets/draw.png";
import { Button } from "../../../../components";

const Votes = () => (
  <>
    <div className="votes-header">
      <p className="text-lg">Who do you think will win?</p>
    </div>
    <div className="p-8">
      <div className="grid votes-teams-box">
        <div className="flex justify-center">
          <img src={Home} />
        </div>
        <div className="flex justify-center items-center">
          <img src={Draw} height={40} />
        </div>
        <div className="flex justify-center">
          <img src={Away} />
        </div>
      </div>
      <div className="grid votes-teams-box">
        <div className="flex justify-center">
          <Button
            type="primary"
            className="mt-0 primary-color button-transparent-quad"
            title="Liverpool"
            style={{
              height: "50px",
              borderRadius: "30px",
              paddingLeft: "2.5em",
              paddingRight: "2.5em",
            }}
          />
        </div>
        <div className="flex justify-center">
          <Button
            type="primary"
            className="mt-0 primary-color button-transparent-quad"
            title="Draw"
            style={{
              height: "50px",
              borderRadius: "30px",
              paddingLeft: "2.5em",
              paddingRight: "2.5em",
            }}
          />
        </div>
        <div className="flex justify-center">
          <Button
            type="primary"
            className="mt-0 primary-color button-transparent-quad"
            title="Man city"
            style={{
              height: "50px",
              borderRadius: "30px",
              paddingLeft: "2.5em",
              paddingRight: "2.5em",
            }}
          />
        </div>
      </div>
    </div>
    
  </>
);

export default Votes;